var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-auth-callback"},[_c('div',{staticClass:"callback-container d-flex flex-column align-center justify-center fill-height"},[_c('v-progress-circular',{staticClass:"mb-4",attrs:{"indeterminate":"","color":"primary","size":"50"}}),_c('p',{staticClass:"text-h6"},[_vm._v("Processing Google authentication...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }